import React from "react"
import "./intro.scss"
import fastPng from "../../images/home/fast.png"
import securePng from "../../images/home/secure.png"
import lowCostPng from "../../images/home/lowcost.png"
import introImg from "../../images/home/intro-img.png"
import { homeLinks } from "../../constants"
import UseIsMobile from "../../hooks/UseIsMobile"

const iconsList = [
  { icon: fastPng, text: "Fast" },
  { icon: securePng, text: "Secure" },
  { icon: lowCostPng, text: "Low cost" },
]

const descText =
  "Celer is a blockchain interoperability protocol enabling a one-click user experience accessing tokens, DeFi, GameFi, NFTs, governance, and more across multiple chains. Developers can build inter-chain-native dApps using the Celer Inter-chain Message SDK to gain access to efficient liquidity utilization, coherent application logic, and shared states. Users of Celer-enabled dApps will enjoy the benefits of a diverse multi-blockchain ecosystem with the simplicity of a single-transaction UX, all from a single chain."

export default function Intro() {
  const [isMobile] = UseIsMobile()
  return (
    <div className="home-intro-bg">
      <div className="intro-top">
        {iconsList.map((item, index) => {
          return (
            <div className="home-icon" key={index}>
              <img src={item.icon} alt=""/>
              <span>{item.text}</span>
            </div>
          )
        })}
      </div>
      <div className="intro-content">
        <div className="content-left">
          <div className="content-left-content">
            <div className="left-title">What is Celer</div>
            <div className="left-desc">{descText}</div>
            {isMobile ? null : (
              <div className="left-link">
                <a
                  href={homeLinks.intro.learnMore}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  learn more
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="content-right">
          <div className="content-right-content">
            <img src={introImg} alt=""/>
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className="bottom-link">
          <a
            href={homeLinks.intro.learnMore}
            target="_blank"
            rel="noopener noreferrer"
          >
            learn more
          </a>
        </div>
      ) : null}
    </div>
  )
}
